import cn from 'classnames';
import { createPortal } from 'preact/compat';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';
import useEmptyPortal from '../hooks/useEmptyPortal';
import { useEffect, useState } from 'preact/hooks';

const MiniCartEl = document.getElementById('preact-mini-cart');

const MiniCart = () => {
  const [cartCount, setCartCount] = useState();
  const { cart, toggleMiniCart } = useCartContext();
  const emptied = useEmptyPortal(MiniCartEl);

  useEffect(() => {
    let count = 0;
    cart.items.forEach(item => {
      if (item.vendor !== 'DailyKarma') {
        count += item.quantity;
      }
    });
    setCartCount(count);
  }, [cart]);

  if (!emptied) {
    return null;
  }

  return createPortal(
    <button
      class="relative"
      onClick={() => {
        toggleMiniCart(true);
      }}
      title={getTranslation('header.cart')}
    >
      <svg className="h-5" viewBox="0 0 18 20" fill="none">
        <path
          d="M13 9V5a4 4 0 1 0-8 0v4M2 7h14l1 12H1L2 7Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>

      {cartCount > 0 && (
        <span
          className={cn(
            'h- absolute -top-1/3 flex h-4 items-center justify-center rounded-full bg-coral pt-px font-mono text-[0.75rem] text-sand',
            {
              '-right-3/4 w-6': cartCount > 99,
              '-right-2/3 w-5': cartCount > 9 && cartCount < 100,
              '-right-1/2 w-4': cartCount < 10,
            },
          )}
        >
          {cart.items ? cartCount : 0}
        </span>
      )}
    </button>,
    MiniCartEl,
  );
};

export default MiniCart;
